<template>
  <v-card flat class="request mt-5" max-width="600" style="margin: auto;">
    <template v-if="$store.state.requestItems.length">
      <v-subheader class="mt-5">お申込みリスト</v-subheader>
      <v-card outlined>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr
                v-for="item in $store.state.requestItems"
                :key="item.id"
                @click="$router.push(`/request/${item.id}`)"
                style="cursor: pointer;"
              >
                <td>{{ item.requested_at }}</td>
                <td class="text-right">{{ userState(item.state) }}</td>
                <td class="text-right" style="width: 4em;">
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </template>

    <v-divider class="mt-5 mb-5" />

    <div class="mt-5 pa-5">
      <p>お申込みの際は、利用規約・個人情報の取り扱いについて<br />をよくお読みください。</p>
      <v-btn text color="primary" @click="toTerms">
        <v-icon left>mdi-text-box-check-outline</v-icon>
        利用規約
      </v-btn>
      <br />
      <v-btn text color="primary" @click="toPrivecy">
        <v-icon left>mdi-text-box-check-outline</v-icon>
        個人情報の取り扱いについて
      </v-btn>
    </div>

    <v-row justify="center" class="ma-0 mt-5">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on">新しくお申込み</v-btn>
        </template>
        <v-card flat>
          <v-toolbar dark flat color="primary">
            <v-toolbar-title>お申込み</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-form lazy-validation ref="form" v-model="formValid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-img src="/files/sample.jpg" max-width="530" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-stepper vertical non-linear v-model="step">
                    <v-stepper-step step="1" editable complete>
                      Step 1
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-file-input
                        outlined
                        placeholder="クリックまたはタップでファイルを選択"
                        chips
                        multiple
                        small-chips
                        truncate-length="15"
                        hint="jpg, jpeg, gif, png, pdf, zip"
                        persistent-hint
                        accept=".jpg,.jpeg,.gif,.png,.pdf,.zip"
                        label="ファイル選択"
                        v-model="files"
                        class="mt-2"
                        @change="stock"
                        ref="files"
                        :rules="[rules.file]"
                      />
                      <div
                        class="drop_area pa-5 ma-5 mb-2"
                        style="border-radius: 5px; border: 2px solid orange;"
                        @dragover.prevent
                        @dragleave.prevent
                        @dragenter.prevent
                        @drop.prevent="drop"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        <span class="grey--text">または ここにドロップ</span>
                      </div>
                      <div
                        v-if="dropError"
                        v-text="dropError"
                        class="red--text subtitle-2 ml-5 mb-5"
                      />
                      <v-card>
                        <v-simple-table>
                          <template v-slot:default>
                            <tbody>
                              <tr v-for="(file, idx) in stockFiles" :key="idx">
                                <td>{{ file.name }}</td>
                                <td style="width: 3em;">
                                  <v-icon @click="deleteStock(file)">mdi-delete</v-icon>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-step step="1" editable complete>
                      Step 2
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-select
                        label="お支払い方法の選択"
                        v-model="paymentMethod"
                        :items="['クレジット決済', '銀行振込']"
                        :rules="[v => !!v || '選択してください']"
                      />
                    </v-stepper-content>
                    <v-stepper-step step="1" editable complete>
                      Step 3
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <div>
                        <v-btn text color="primary" @click="toTerms">
                          <v-icon left>mdi-text-box-check-outline</v-icon>
                          利用規約
                        </v-btn>
                        <br />
                        <v-btn text color="primary" @click="toPrivecy">
                          <v-icon left>mdi-text-box-check-outline</v-icon>
                          個人情報の取り扱いについて
                        </v-btn>
                      </div>
                      <div class="d-flex justify-center">
                        <v-btn
                          color="primary"
                          class="mt-5"
                          @click="save"
                          :disabled="stockFiles.length === 0"
                        >
                          利用規約・個人情報の取り扱いについて同意して申し込む
                        </v-btn>
                      </div>
                    </v-stepper-content>
                  </v-stepper>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                </v-col>
              </v-row>
              <v-row class="pt-5">
                <v-col cols="12">
                </v-col>
              </v-row>
              <v-row class="pt-5">
                <v-col cols="12" class="d-flex justify-center pt-5">
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="completeDialog" max-width="300">
        <v-card>
          <v-card-title>お申込み完了</v-card-title>
          <v-card-text>
            <p>お申し込みを承りました。</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="grey darken-2" @click="closeComplete">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </v-card>
</template>

<script>

const checkFile = (files) => {
  const extList = [
    'jpg', 'jpeg', 'png', 'gif', 'zip', 'pdf',
    'JPG', 'JPEG', 'PNG', 'GIF', 'ZIP', 'PDF',
  ];
  const reExt = /\.([^.]+)$/;
  if (
    files.find((file) => {
      const reResult = file.name.match(reExt);
      if (extList.includes(reResult[1])) {
        return false;
      }
      return true;
    })
  ) {
    return false;
  }
  return true;
};

export default {
  name: 'Request',

  props: [
    'newRoot'
  ],

  data: () => ({
    dialog: false,
    completeDialog: false,
    files: [],
    stockFiles: [],
    paymentMethod: null,
    formValid: true,
    step: 1,
    rules: {
      file: (value) => checkFile(value) || 'アップロードできない種類が含まれています'
    },
    dropError: '',
  }),
  mounted() {
    if (this.$store.state.loggedIn === false) {
      this.$store.commit('setAfterLoginPath', '/request');
      this.$router.push('/');
    } else {
      this.$store.dispatch('getRequestItems').then(() => {
        if (this.newRoot) {
          this.dialog = true;
        }
      })
        .catch((err) => {
          if (err.response.status === 403) {
            this.$store.commit('setAfterLoginPath', '/request');
            alert('認証エラー：ログインページへ移動します。');
            this.$router.push('/');
          } else {
            alert('Server error.');
          }
        });
    }
  },
  methods: {
    userState(state) {
      if (state === '件数確認済') {
        return '件数確認';
      }
      return state;
    },
    stock() {
      if (this.files.length === 0) {
        return;
      }
      if (!checkFile(this.files)) {
        return;
      }
      if (this.files.length > 0) {
        this.stockFiles = [...this.stockFiles, ...this.files];
        this.files = [];
      }
    },
    deleteStock(item) {
      this.stockFiles = this.stockFiles.filter((fileItem) => {
        return item !== fileItem;
      });
    },
    save() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      const reqData = new FormData();
      reqData.append('payment_method', this.paymentMethod);
      reqData.append('file_number', this.stockFiles.length);
      this.stockFiles.forEach((file, idx) => {
        reqData.append(`file${idx}`, file);
      });
      this.$store.dispatch('postRequest', reqData)
        .then(() => {
          this.$store.dispatch('getRequestItems');
          this.stockFiles = [];
          this.completeDialog = true;
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.$store.commit('setAfterLoginPath', '/request');
            alert('認証エラー：ログインページへ移動します。');
            this.$router.push('/');
          } else {
            alert('Server error.');
          }
        });
    },
    closeComplete() {
      this.completeDialog = false;
      this.dialog = false;
    },
    toTerms() {
      window.open('/termsofuse/');
    },
    toPrivecy() {
      window.open('/privacy/pp-registration.php');
    },
    drop(event) {
      event.preventDefault();
      console.log(Array.from(event.dataTransfer.files));
      if (!checkFile(Array.from(event.dataTransfer.files))) {
        this.dropError = 'アップロードできない種類が含まれています';
        setTimeout(() => {
          this.dropError = '';
        }, 2000);
        return;
      }
      this.stockFiles.push(...event.dataTransfer.files);
    }
  }
};
</script>
